import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import ButtonComponent from "../../components/ButtonComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightDots,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { RESTAURANT_ID } from "../../constants/constans";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  Category,
  useGetCategoryListByRestaurantIdQuery,
} from "../../redux/services/categoryServise";
import img1 from "../../assets/images/IM0201.PNG";
import img4 from "../../assets/images/IM0203.PNG";
import img5 from "../../assets/images/IM0204.PNG";
import logo from "../../assets/images/logo1.PNG";
import "./index.css";
import ourpromiseimg1 from "../../assets/images/OurPromise01.PNG";
import ourpromiseimg2 from "../../assets/images/OurPromise02.PNG";
import ourpromiseimg3 from "../../assets/images/OurPromise03.PNG";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { scrollbarData } from "../../dummyData/scrollBarData";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import FeedbackCard from "../../components/CustomerFeedBackCard";
import readyToFeast from "../../assets/images/ReadytoFeast.PNG";
import {
  useGetInitialDataQuery,
} from "../../redux/services/initialDataService";
import { Alert } from "reactstrap";
import defaultBackground from "../../assets/images/IME01.PNG";
import QuantityChangeButton from "../../components/QuantityChangeButton";
import { useDispatch } from "react-redux";
import { setInitialData } from "../../redux/initialDataSlice";
import { Link } from "react-router-dom";
import {
  fetchRestaurantFailure,
  fetchRestaurantStart,
  fetchRestaurantSuccess,
} from "../../redux/restaurantSlice";
import { useGetRestaurantByIdMutation } from "../../redux/services/getResturent";
import { useGetMenuCustomListFromCustomerSiteQuery, useGetMenuSetListFromCustomerSiteQuery, useGetMenuSingleListFromCustomerSiteQuery } from "../../redux/services/setMenuService";
import img2 from "../../assets/images/Defult.PNG";
import useImageLoader from "./ImageLoaderHook";

export interface MenuItem {
  portions: any;
  supportPortionSizes: any;
  id: string;
  items: any;
  imageUrl: any;
  displayName: string;
  itemId: string;
  itemType: string;
  price: number;
  allergenInformation?: string[];
  foodAttributes?: string[];
  availableDays?: number[];
  availableItemCount?: number;
  isAvailable: boolean;
  supportsPreOrdering?: boolean;
  filterTags?: string[];
  tags: any;
  description?: string;
}

const Home = () => {
  const restaurantId = RESTAURANT_ID;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const imageRef = useRef<HTMLImageElement>(null);
  const scrollbarRef = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [categories, setCategories] = useState<Category[]>([]);
  const [scrollbarHeight, setScrollbarHeight] = useState<number>(800);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isHeroImageLoaded, setIsHeroImageLoaded] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState<boolean>(false);

  const { data } = useGetCategoryListByRestaurantIdQuery(restaurantId);

  const { data: initialData, isLoading, error } = useGetInitialDataQuery();
  const [getRestaurantById] = useGetRestaurantByIdMutation();

  const { data: singleMenuData, isLoading: singleMenuLoading } =
    useGetMenuSingleListFromCustomerSiteQuery(restaurantId);

  const { data: setMenuData, isLoading: setMenuLoading } =
    useGetMenuSetListFromCustomerSiteQuery(restaurantId);

  const { data: customMenuData } =
    useGetMenuCustomListFromCustomerSiteQuery(restaurantId);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const singleMenuItems: MenuItem[] = useMemo(
    () => singleMenuData?.menusItems || [],
    [singleMenuData]
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setMenuItem: MenuItem[] = setMenuData?.setMenus || [];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const customMenuItem: MenuItem[] = customMenuData?.customMenus || [];

  useEffect(() => {
    if (initialData) {
      dispatch(setInitialData(initialData));
    }
  }, [initialData, dispatch]);

  useEffect(() => {
    if (singleMenuLoading || setMenuLoading) {
      setIsPageLoading(true);
    } else {
      setIsPageLoading(false);
    }
  }, [isPageLoading, singleMenuLoading, setMenuLoading]);

  useEffect(() => {
    if (data && data.categories) {
      setCategories(data.categories);
    }
  }, [data]);

  const heroImageUrl = initialData?.home?.topBanner?.imageUrl;
  const { isLoaded: isHeroLoaded, error: heroError } = useImageLoader(heroImageUrl);

  // const { isLoaded: isImg1Loaded } = useImageLoader(img1);
  // const { isLoaded: isImg4Loaded } = useImageLoader(img4);
  // const { isLoaded: isImg5Loaded } = useImageLoader(img5);
  // const { isLoaded: isPromiseImg1Loaded } = useImageLoader(ourpromiseimg1);
  // const { isLoaded: isPromiseImg2Loaded } = useImageLoader(ourpromiseimg2);
  // const { isLoaded: isPromiseImg3Loaded } = useImageLoader(ourpromiseimg3);
  // const { isLoaded: isLogoLoaded } = useImageLoader(logo);

  const isHeroReady = !isLoading && isHeroLoaded;
  // Preload hero image on component mount + when initialData changes
  useEffect(() => {
    if (!initialData?.home?.topBanner?.imageUrl) return;

    const img = new Image();
    img.src = initialData.home.topBanner.imageUrl;
    img.onload = () => setIsHeroImageLoaded(true);
    img.onerror = () => setIsHeroImageLoaded(true);

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [initialData]);


  // const isHeroReady = !isLoading && isHeroImageLoaded;

  useEffect(() => {
    const fetchRestaurant = async () => {
      dispatch(fetchRestaurantStart());
      try {
        const response = await getRestaurantById(restaurantId).unwrap();
        dispatch(fetchRestaurantSuccess(response));
      } catch (error) {
        dispatch(fetchRestaurantFailure("Failed to load restaurant"));
      }
    };

    fetchRestaurant();
  }, [restaurantId, dispatch, getRestaurantById]);

  if (error) {
    <Alert>Error Loading Data</Alert>;
  }

  useEffect(() => {
    const updateHeight = () => {
      if (imageRef.current) {
        const imgHeight = imageRef.current.offsetHeight;
        setScrollbarHeight(imgHeight);
      }
    };

    const imageElement = imageRef.current;
    if (imageElement && imageElement.complete) {
      updateHeight();
    } else if (imageElement) {
      imageElement.addEventListener("load", updateHeight);
    }

    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      if (imageElement) {
        imageElement.removeEventListener("load", updateHeight);
      }
    };
  }, []);

  const handleClickNavigate = () => {
    navigate("/order");
  };
  const handleCartList = () => {
    navigate("/shoppingCart");
  };

  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <button className="custom-next" onClick={onClick}>
      <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
    </button>
  );

  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <button className="custom-prev" onClick={onClick}>
      <FontAwesomeIcon icon={faChevronLeft} className="arrow-icon" />
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1340,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 510,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const findDishDetails = (id: string, itemType: string) => {
    switch (itemType) {
      case 'MenuItem':
        return singleMenuData?.menusItems?.find((item: MenuItem) => item.itemId === id);
      case 'setMenu':
        return setMenuData?.setMenus?.find((item: MenuItem) => item.itemId === id);
      case 'customMenu':
        return customMenuData?.customMenus?.find((item: MenuItem) => item.itemId === id);
      default:
        return null;
    }
  };

  const findProductDetails = (itemId: string, itemType: string) => {
    switch (itemType) {
      case 'MenuItem':
        return singleMenuData?.menusItems?.find((item: MenuItem) => item.id === itemId || item.itemId === itemId);
      case 'setMenu':
        return setMenuData?.setMenus?.find((item: MenuItem) => item.id === itemId || item.itemId === itemId);
      case 'customMenu':
        return customMenuData?.customMenus?.find((item: MenuItem) => item.id === itemId || item.itemId === itemId);
      default:
        return null;
    }
  };

  const sliderProductsWithDetails = useMemo(() => {
    return initialData?.home?.sliderProducts?.map(product => {
      const details = findProductDetails(product.itemId, product.itemType);
      return {
        ...product,
        ...details,
        // Ensure we have the required properties
        image: details?.imageUrl || img2,
        display: details?.displayName || 'Unknown Product'
      };
    }).filter(product => product.image && product.display) || [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData, singleMenuData, setMenuData, customMenuData,]);

  // const allImagesLoaded = useMemo(() => {
  //   return (
  //     isHeroLoaded &&
  //     isImg1Loaded &&
  //     isImg4Loaded &&
  //     isImg5Loaded &&
  //     isPromiseImg1Loaded &&
  //     isPromiseImg2Loaded &&
  //     isPromiseImg3Loaded &&
  //     isLogoLoaded
  //     // Add other images as needed
  //   );
  // }, [
  //   isHeroLoaded,
  //   isImg1Loaded,
  //   isImg4Loaded,
  //   isImg5Loaded,
  //   isPromiseImg1Loaded,
  //   isPromiseImg2Loaded,
  //   isPromiseImg3Loaded,
  //   isLogoLoaded,
  // ]);

  return (
    <>
      {isLoading || !isHeroReady ? (
        <div>
          <div className="loader-wrapper">
            <div className="loader"></div>
          </div>
        </div>
      ) : (
        <div>
          {/* <Dashboard01/> */}
          <header
            className="hero"
            // style={{
            //   background:
            //     `url(${initialData?.home?.topBanner?.imageUrl}) no-repeat center center/cover` ||
            //     defaultBackground,
            // }}
            style={{
              background: heroError
                ? `url(${defaultBackground}) no-repeat center center/cover`
                : `url(${heroImageUrl || defaultBackground}) no-repeat center center/cover`,
              transition: 'opacity 0.5s ease',
              opacity: isHeroReady ? 1 : 0
            }}
          >
            <Container className="text-start">
              <h1>{initialData?.home?.topBanner?.textOverlay?.title}</h1>
              <p>{initialData?.home?.topBanner?.textOverlay?.description}</p>
            </Container>
            <Container className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2">
                <ButtonComponent
                  title="Explore Menu"
                  backgroundColor="#FF1001"
                  onClick={handleClickNavigate}
                  icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                />
              </div>
              {/* <Button size="sm" className="dash-01-chat-btn">
                                <FontAwesomeIcon icon={faComments} size="xl" />
                            </Button> */}
            </Container>
          </header>
          {/* <RotatingItems /> */}
          <div className="rotating-container">
            <div className="rotating-track">
              {sliderProductsWithDetails.map((product, index) => (
                <div className="rotating-item" key={`product-${index}`}>
                  <img
                    src={product.image}
                    alt={product.display}
                    className="rotating-image"
                  />
                  <p className="rotating-label">{product.display}</p>
                </div>
              ))}
              {sliderProductsWithDetails.map((product, index) => (
                <div className="rotating-item" key={`product-repeat-1-${index}`}>
                  <img
                    src={product.image}
                    alt={product.display}
                    className="rotating-image"
                  />
                  <p className="rotating-label">{product.display}</p>
                </div>
              ))}
              {sliderProductsWithDetails.map((product, index) => (
                <div className="rotating-item" key={`product-repeat-2-${index}`}>
                  <img
                    src={product.image}
                    alt={product.display}
                    className="rotating-image"
                  />
                  <p className="rotating-label">{product.display}</p>
                </div>
              ))}
              {sliderProductsWithDetails.map((product, index) => (
                <div className="rotating-item" key={`product-repeat-3-${index}`}>
                  <img
                    src={product.image}
                    alt={product.display}
                    className="rotating-image"
                  />
                  <p className="rotating-label">{product.display}</p>
                </div>
              ))}
            </div>
          </div>
          {/* <Dashboard02 /> */}
          <Row className="w-100 h-100 m-0 bg-black">
            <Col xs="12" lg="4" className="main-dash-02-col">
              <img
                src={img1}
                alt="img1"
                className="w-100 h-100 dashboard-side-img"
              />
            </Col>
            <Col
              xs="12"
              lg="4"
              className="main-dash-02-col d-flex align-items-center justify-content-center"
            >
              <div className="middle-img-content py-4 py-4 text-center">
                <img src={logo} alt="logo" className="middle-img-logo mb-3" />
                <h2>Welcome to Curry king</h2>
                <p className="p-4">
                  Curry King is more than just a meal; it's an experience. We
                  bring the treasures of South Asian spices and the comforts of
                  home-style cooked rice and curry to your busy life. Designed
                  for the discerning palate, our meals are a celebration of
                  flavor and convenience.
                </p>
                <ButtonComponent
                  title="Explore Menu"
                  icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                  onClick={handleClickNavigate}
                  backgroundColor="#FFC100"
                  color="black"
                />
              </div>
            </Col>
            <Col xs="12" lg="4" className="main-dash-02-col">
              <img
                src={img4}
                alt="img1"
                className="w-100 h-100 dashboard-side-img"
              />
            </Col>
          </Row>
          {/* <OurPromise /> */}
          <div className="our-promise-container">
            <h1>Our Promise</h1>
            <div className="promise-cards">
              <div className="promise-card">
                <div className="icon-container">
                  <img src={ourpromiseimg1} alt="icon" />
                </div>
                <h4>Quality Commitment</h4>
                <p>
                  Crafted with care, every meal meets our highest standards of
                  freshness, flavour, and food safety.
                </p>
              </div>
              <div className="promise-card">
                <div className="icon-container">
                  <img src={ourpromiseimg2} alt="icon" />
                </div>
                <h4>Consistent Service</h4>
                <p>
                  Connected to understand your preferences — delivering them
                  with excellence to make every pack truly delicious.
                </p>
              </div>
              <div className="promise-card">
                <div className="icon-container">
                  <img src={ourpromiseimg3} alt="icon" />
                </div>
                <h4>Community Focus</h4>
                <p>
                  Nourishing communities through local sourcing, jobs, and
                  hospitality — eagerly incorporating your suggestions every
                  step of the way.
                </p>
              </div>
            </div>
          </div>
          {/* <SignatureDishes /> */}
          <div className="signature-dishes-container">
            <h1>Signature Dishes</h1>
            <p className="signature-dishes-container-description">
              Every dish at Curry King tells a story of heritage and passion.
              Our signature rice and curry meals are expertly crafted by our
              chefs to be nutritionally balanced, delicious, and full of
              authentic Sri Lankan flavor — a true must-try for any food lover.
            </p>
            {isLoading ? (
              <div className="signature-dishes-loading text-center py-5">
                <div className="spinner-border text-warning" role="status">
                  <span className="visually-hidden">
                    Loading Signature Dishes...
                  </span>
                </div>
              </div>
            ) : (
              <Slider {...settings}>
                {initialData?.home?.signatureDishes.map((dish:any) => {
                  // Get the full dish details based on itemType
                  const fullDish = findDishDetails(dish.id, dish.itemType);

                  if (!fullDish) return null; // Skip if dish not found

                  return (
                    <div className="dish-card" key={fullDish.id}>
                      <img
                        src={fullDish.imageUrl}
                        alt={fullDish.displayName}
                        className="dish-card-img"
                      />
                      <h3>{fullDish.displayName}</h3>
                      <div className="price-container">
                        <span>Product Id: {fullDish.productId}</span>
                        <span>LKR: {fullDish.price}</span>
                      </div>

                      <p className="dish-card-description">{fullDish.description}</p>
                      <div className="d-flex justify-content-between align-items-center">
                        <QuantityChangeButton
                          id={fullDish.id}
                          name={fullDish.displayName}
                          price={Number(fullDish.price)}
                          description={fullDish.description}
                          imageUrl={fullDish.imageUrl}
                          portionName={""}
                          additionalCost={0}
                        />
                        <ButtonComponent
                          title="Order Now"
                          icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                          backgroundColor="#FF1001"
                          onClick={handleCartList}
                        />
                      </div>
                    </div>
                  );
                })}
              </Slider>
            )}
          </div>
          {/* <Dashboard03 /> */}
          <Row className="p-4 mt-5 dashboard-columns d-flex justify-content-center align-items-center">
            <Col xs={12} lg={6} className="my-4 mb-lg-0">
              <img
                ref={imageRef}
                src={img5}
                alt="Dashboard03"
                className="dashbaord-03-img w-100"
              />
            </Col>
            <Col xs={12} lg={6}>
              <PerfectScrollbar
                ref={scrollbarRef}
                className="scrollbar-container"
                style={{ height: `${scrollbarHeight}px`, paddingLeft: "70px" }}
              >
                <h1 className="px-5 dashboard03-content-header mb-5">
                  Order in Just a Few Clicks
                </h1>
                {scrollbarData.map((item, index) => (
                  <div key={index} className="scrollbar-content">
                    <div className="d-flex align-items-start gap-3">
                      <img src={item.icon} alt="icon" className="icon-img" />
                      <div className="d-flex flex-column">
                        <h1 className="scrollbar-title mb-4">{item.title}</h1>
                        <p className="scrollbar-text">{item.content}</p>
                        <Link to="/order" className="mb-4 text-black">
                          Order Now{" "}
                          <FontAwesomeIcon
                            icon={faArrowUpRightDots}
                            className="px-1"
                          />
                        </Link>
                        
                      </div>
                    </div>
                  </div>
                ))}
              </PerfectScrollbar>
            </Col>
          </Row>
          {/* <CustomerFeedBack /> */}
          <div className="customer-feedback-container">
            <h1 className="mb-5 mt-3">
              Hear from the Loyal Citizens of Curry Kingdom
            </h1>
            <Row>
              {initialData?.home?.userReviews?.map(
                (userReviews: any, index: any) => (
                  <Col md={6} lg={4} key={index}>
                    <FeedbackCard {...userReviews} />
                  </Col>
                )
              )}
            </Row>
          </div>
          {/* <ReadyToFeast /> */}
          <div className="ready-to-feast-container text-center py-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-10 position-relative">
                  <div className="ready-to-feast-image-wrapper">
                    <img
                      src={readyToFeast}
                      alt="Ready to Feast"
                      className="img-fluid rounded-3"
                    />
                    <div className="overlay-text text-white text-center">
                      <h1 className="display-4 fw-bold">Ready to Feast</h1>
                      <p className="lead">
                        Indulge in the royal flavors of Curry King. Place your
                        order now and enjoy an unforgettable meal.
                      </p>
                      <ButtonComponent
                        title="Order Food"
                        onClick={handleClickNavigate}
                        backgroundColor="#000000"
                        icon={<FontAwesomeIcon icon={faArrowUpRightDots} />}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
